import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';


const
	CLASS_ACTIVE = 'is-active',
	SELECTOR_TAB = '.tab',
	SELECTOR_TABPANEL = '.tabpanel'
;

class View extends BaseView {

	events() {
		return {
			'click .tab': '_onClick'
		};
	}

	_onClick(e) {
		const
			$el = $(e.currentTarget),
			$tabs = this.$el.find(SELECTOR_TAB),
			$tabpanel = this.$el.find(`${SELECTOR_TABPANEL}#${$el.attr('aria-controls')}`)
		;

		e.preventDefault();
		$tabs.removeClass(CLASS_ACTIVE).attr('aria-selected', false);
		$el.addClass(CLASS_ACTIVE).attr('aria-selected', true);
		$tabpanel.addClass(CLASS_ACTIVE).attr('aria-hidden', false)
			.siblings(SELECTOR_TABPANEL).removeClass(CLASS_ACTIVE).attr('aria-hidden', true);

		// Fix slideshow height inside hidden tabpanels
		$tabpanel.find('.slideshow').get(0)?.slick.setPosition();
	}

}

export default View;
